<style lang="css">
  .header-wrap {
    border-bottom: 1px solid #ccc;
    position: relative;
    display: flex;
    padding: 5px 0;
    align-items: center;
    box-sizing: border-box;
  }

  .header-title {
    margin-top: -5px;
  }

  .header-search {
    margin-left: 20px;
  }

  .search-input .vxe-input--inner {
    /*height: 34px;*/
    border: 1px solid #ccc;
  }

  .maxsize {
    position: absolute;
    right: 40px;
    top: 5px;
    height: 20px;
    width: 20px;
    cursor: pointer;
  }

  .close {
    position: absolute;
    right: 10px;
    top: 5px;
    height: 20px;
    width: 20px;
    cursor: pointer;
  }
</style>


<template>
  <div class="header-wrap">
    <div class="header-title">
      <h3>{{ title }}</h3>
    </div>
    <div class="header-search my-search" style="display: flex;align-items: center;">
      <vxe-input
          type="text"
          class="search-input"
          v-model="searchKeywordAccount"
          :placeholder="searchAccountPlaceholder"
          size="medium"
          clearable
      ></vxe-input>
      <vxe-input
          type="text"
          class="search-input"
          v-model="searchKeyword"
          :placeholder="searchPlaceholder"
          size="medium"
          style="margin-left:10px"
          clearable
      ></vxe-input>
      <Button type="primary" icon="ios-search" @click="search" style="margin-left: 10px;border-radius: 4px;">搜索</Button>
    </div>
    <div class="maxsize">
      <!-- <i class="vxe-icon--zoomin"></i> -->
    </div>
    <div class="close" @click="close">
      <i class="vxe-icon--close"></i>
    </div>
  </div>
</template>
<script>
  export default {
    name: "ModalHeader",
    props: {
      title: {
        type: String,
        default: "弹窗"
      },
      searchPlaceholder: {
        type: String,
        default: "账户名称"
      },
      searchAccountPlaceholder: {
        type: String,
        default: "银行账号"
      }
    },
    data() {
      return {
        searchKeyword: "",
        searchKeywordAccount: ""
      };
    },
    methods: {
      clear() {
        this.searchKeyword = "";
        this.searchKeywordAccount = "";
      },
      search() {
        this.$emit("search", this.searchKeyword, this.searchKeywordAccount);
      },
      close() {
        this.$emit("close");
      }
    }
  };
</script>